import { useState, useEffect } from 'react';

export const useLayout = (key, initialValue) => {

    const [ storedValue, setStoredValue ] = useState(() => {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error("Error reading localStorage:", error);
            return initialValue;
        }
    });
  
    useEffect(() => {
        try {
            if (storedValue === null) {
                window.localStorage.removeItem(key);
            } else {
                window.localStorage.setItem(key, JSON.stringify(storedValue));
            }
        } catch (error) {
            console.error("Error writing to localStorage:", error);
        }
    }, [key, storedValue]);
  
    return [ storedValue, setStoredValue ];
};